import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class DocumentDetail extends BaseModel {
    @Expose() id = "";
    @Expose() name = "";
    @Expose() stream = "";
    @Expose() url = ""; // server could respond with url or stream
    @Expose() type = "";
}
